import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicLayoutComponent } from './public-layout/public-layout.component';
import { OnlineEssayLayoutComponent } from './online-essay-layout/online-essay-layout.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { UserLayoutComponent } from './user-layout/user-layout.component';
import { SharedMaterialModule } from './shared-material.module';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { JudgeGuard } from './guards/judge.guard';
import { TeacherGuard } from './guards/teacher.guard';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar'
import { AppComfirmComponent } from './app-confirm.component';
import { DeviceStatusComponent } from './device-status/device-status.component';
import { CheckOutComponent } from './device-status/check-out/check-out.component';
import { DeviceOperationComponent } from './device-status/device-operation/device-operation.component';
import { FormsModule } from '@angular/forms';
import { EntityContactsComponent } from './entity-contacts/entity-contacts.component';
import { FileSaverModule } from 'ngx-filesaver';
import { SchoolAnalyticsComponent } from '../shared/school-analytics/school-analytics.component';
import { DevicesSynchedReportComponent } from '../shared/school-analytics/devices-synched-report/devices-synched-report.component';
import { AppUtilizationReportComponent } from '../shared/school-analytics/app-utilization-report/app-utilization-report.component';
import { LearnerPerformanceComponent } from './school-analytics/learner-performance/learner-performance.component';
import { MostWatchedComponent } from './school-analytics/most-watched/most-watched.component';
import { MostWatchedByThemeComponent } from './school-analytics/most-watched-by-theme/most-watched-by-theme.component';
import { Pp2VocabQuizReportComponent } from './school-analytics/pp2-vocab-quiz-report/pp2-vocab-quiz-report.component';
import { TitleReportComponent } from './school-analytics/title-report/title-report.component';
import { SubjectReportComponent } from './school-analytics/subject-report/subject-report.component';
import { TimeUsedReportComponent } from './school-analytics/time-used-report/time-used-report.component';
import { UtilGridReportComponent } from './school-analytics/util-grid-report/util-grid-report.component';
import { UtilDeviceReportComponent } from './school-analytics/util-device-report/util-device-report.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DateRangePopupComponent } from './date-range-popup/date-range-popup.component';
import { XAPIFormComponent } from './x-api-form/x-api-form.component';
import { IconComponent } from './icon/icon.component';
import { TranslatePipe } from '../online-essay/services/translate-pipe';
import { YoutubeVideoViewsComponent } from './school-analytics/youtube-video-views/youtube-video-views.component';
import { YoutubeCategoryViewsComponent } from './school-analytics/youtube-category-views/youtube-category-views.component';



@NgModule({
  declarations: [
    PublicLayoutComponent,
    OnlineEssayLayoutComponent,
    AdminLayoutComponent,
    UserLayoutComponent,
    AppComfirmComponent,
    DeviceStatusComponent,
    CheckOutComponent,
    DeviceOperationComponent,
    EntityContactsComponent,
    SchoolAnalyticsComponent,
    DevicesSynchedReportComponent,
    AppUtilizationReportComponent,
    LearnerPerformanceComponent,
    MostWatchedComponent,
    MostWatchedByThemeComponent,
  Pp2VocabQuizReportComponent,
    TitleReportComponent,
    SubjectReportComponent,
    TimeUsedReportComponent,
    UtilGridReportComponent,
    UtilDeviceReportComponent,
    DateRangePopupComponent,
    XAPIFormComponent,
    IconComponent,
    YoutubeVideoViewsComponent,
    YoutubeCategoryViewsComponent,

  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    SharedMaterialModule,
    NgScrollbarModule,
    FileSaverModule,
    NgxChartsModule,
  ],
  providers:[
    AuthGuard,
    AdminGuard,
    JudgeGuard,
    TeacherGuard
  ],
  exports: [
    PublicLayoutComponent,
    OnlineEssayLayoutComponent,
    AdminLayoutComponent,
    UserLayoutComponent,
    NgScrollbarModule,
    DeviceStatusComponent,
    EntityContactsComponent,
    FileSaverModule,
    SchoolAnalyticsComponent,
    DevicesSynchedReportComponent,
    AppUtilizationReportComponent,
    LearnerPerformanceComponent,
    MostWatchedComponent,
    MostWatchedByThemeComponent,
  Pp2VocabQuizReportComponent,
    TitleReportComponent,
    SubjectReportComponent,
    TimeUsedReportComponent,
    UtilGridReportComponent,
    DateRangePopupComponent,
    XAPIFormComponent,
    IconComponent,
    YoutubeVideoViewsComponent,
    YoutubeCategoryViewsComponent,
    NgxChartsModule

  ]
})
export class SharedModule { }
